import React from 'react';
import ModemsList from './components/ModemsList';

const ModemsView = () => (
  <ModemsList />
);

export default ModemsView;
